import { call, put } from 'redux-saga/effects'
import { RequestMethods } from 'utils/axios/methods'
import type { PayloadAction } from '@reduxjs/toolkit'
import { sagaAction_Error } from 'redux/sagas/actions/SagaAction_Error'
import { Actions_Notifications } from 'redux/modules/notification/Actions'
import { Actions_ParkingNotes } from 'redux/modules/parkingNotes/Actions'
import SagaWorker_GetParkingNotes from './SagaWorker_GetParkingNotes'

const { remove } = RequestMethods()

export interface ISagaWorker_DeleteParkingNote {
  id: number
  parkingId: number
}

export default function* SagaWorker_DeleteParkingNote(action: PayloadAction<ISagaWorker_DeleteParkingNote>) {
  try {
    yield put(Actions_ParkingNotes.store.showLoader())

    const { id } = action.payload

    yield call(async () => await remove(`/notes/${id}`))

    yield call(SagaWorker_GetParkingNotes, action)

    yield put(
      Actions_Notifications.store.setNotification({
        message: 'The note has been successfully deleted',
        type: 'Success',
      }),
    )
  } catch (e) {
    yield call(() => sagaAction_Error(e))
  } finally {
    yield put(Actions_ParkingNotes.store.hideLoader())
  }
}
